import { TermsCondContext } from './TermsCondContext'
import { useEffect, useMemo, useState } from 'react'
import { sweetError } from '@/utils/sweetalert2'
import { termsAsync, privacyAsync } from '@/services/axios/guest/general'

export const TermsCondProvider = ({ children }) => {
  const [terms, setTerms] = useState([])
  const [policy, setPolicy] = useState([])

  useEffect(() => {
    const getTerms = async () => {
      try {
        const { data: { records: { content } } } = await termsAsync()
        setTerms(
          content
        )
      } catch (e) {
        sweetError('', e)
      }
    }
    getTerms()
  }, [])

  useEffect(() => {
    const getPolicy = async () => {
      try {
        const { data: { records: { content } } } = await privacyAsync()
        setPolicy(
          content
        )
      } catch (e) {
        sweetError('', e)
      }
    }
    getPolicy()
  }, [])

  const props = useMemo(() => ({
    terms,
    policy
  }), [terms, policy])

  return (
    <TermsCondContext.Provider value={props}>
      {children}
    </TermsCondContext.Provider>
  )
}
